/**
 * In den POLICY_PREFERENCES sind die unterschiedlichen Verhaltensweisen von
 * Wenja je nach Policy festgelegt. Nach Laden der Customization steht die zu
 * verwendende Policy fest und es gilt dann genau ein Regelset.
 *
 * In https://projects.dfn-cert.de/mtrac/openca/ticket/1833#comment:3 ist die
 * Idee dokumentiert.
 */
export const POLICY_PREFERENCES = {
  Global: {
    newRequest: {
      showDomains: true,
      noGNSN: false,
      dontSetPseudonym: false,
      showOnlySTLPrefixesForServer: true,
    },
    hideAllRequestPages: true,
    hidePseudonym: false,
    hideGroup: false,
    hideServer: true,
    showNotification: true,
    policyUrl: "https://doku.tid.dfn.de/de:dfnpki:global",
  },
  Grid: {
    newRequest: {
      showDomains: true,
      noGNSN: true,
      dontSetPseudonym: true,
      showOnlySTLPrefixesForServer: false,
    },
    hideAllRequestPages: false,
    hidePseudonym: true,
    hideGroup: true,
    hideServer: false,
    showNotification: false,
    policyUrl: "https://doku.tid.dfn.de/de:dfnpki:grid",
  },
  Community: {
    newRequest: {
      showDomains: true,
      noGNSN: true,
      dontSetPseudonym: true,
      showOnlySTLPrefixesForServer: false,
    },
    hideAllRequestPages: false,
    hidePseudonym: false,
    hideGroup: false,
    hideServer: false,
    showNotification: false,
    policyUrl:
      "https://doku.tid.dfn.de/_media/de:dfnpki:doc:dfn-verein_community_pki_cps.pdf",
  },
  eduPKI: {
    newRequest: {
      showDomains: false,
      noGNSN: true,
      dontSetPseudonym: false,
      showOnlySTLPrefixesForServer: false,
    },
    hideAllRequestPages: false,
    hidePseudonym: true,
    hideGroup: false,
    hideServer: false,
    showNotification: false,
    policyUrl:
      "https://www.edupki.org/fileadmin/Documents/eduPKI-CA-CP-CPS.pdf",
  },
  Kommerz: {
    newRequest: {
      showDomains: false,
      noGNSN: true,
      dontSetPseudonym: false,
      showOnlySTLPrefixesForServer: false,
    },
    hideAllRequestPages: false,
    hidePseudonym: false,
    hideGroup: false,
    hideServer: false,
    showNotification: false,
    policyUrl: "https://pki.dfn-cert.de/cpcps.pdf",
  },
  Internal: {
    newRequest: {
      showDomains: false,
      noGNSN: true,
      dontSetPseudonym: false,
      showOnlySTLPrefixesForServer: false,
    },
    hideAllRequestPages: false,
    hidePseudonym: false,
    hideGroup: false,
    hideServer: false,
    showNotification: false,
    policyUrl: null,
  },
};
